import classNames from "classnames";

import { CombinedNamespacePaths } from "./common";
import { FilterItem, FilterItemsGroup } from "./filter-items";
import { FilterSetItem } from "./filter-sets";
import { QESButton } from "@app/shared/qes-standards";
import { JSX } from "react";

interface ActiveFiltersProps {
  filterGroups: FilterItemsGroup[];
  pendingFilterGroups?: FilterItemsGroup[];

  onRemoveFilterGroup?: (filterGroup: FilterItemsGroup) => void;
  onRemovePendingFilterGroup?: (filterGroup: FilterItemsGroup) => void;
}

/** Displays the currently active filters. This includes both saved and pending filters. */
function ActiveFilters(props: ActiveFiltersProps): JSX.Element {
  // Build out our filter components.
  const filters = (props.filterGroups || []).map((sf, i) => (
    <FilterGroup
      key={i}
      items={sf.filters}
      onClick={() => props.onRemoveFilterGroup(sf)}
    />
  ));
  const pendingFilters = (props.pendingFilterGroups || []).map((pf, i) => (
    <FilterGroup
      key={`pending-${i}`}
      items={pf.filters}
      pending={true}
      onClick={() => props.onRemovePendingFilterGroup(pf)}
    />
  ));

  const components = [...filters, ...pendingFilters];

  // Take the components and interleave them with separators.
  return (
    <>
      {
        components
          .reduce((arr, c, i) => {
            return i === components.length - 1
              ? arr.concat(c)
              : arr.concat(c, (
                <AndSeparator key={`separator-${i}`} />
              ));
          }, [])
      }
    </>
  );
}

/**
 * Represents a distinct group of filters in the UI.
 * This is the bordered region that displays the path.
 */
function FilterGroup(props: { items: Array<(FilterItem | FilterSetItem)>, pending?: boolean, onClick: () => void }) {
  const { items, pending, onClick } = props;
  const namespaceItems = items?.map((c) => c.namespacePath) || [];

  return (
    <li className={classNames("resource-filter", { pending })}>
      <QESButton
        qesType="none"
        className="active-filters-button"
        qesTestId={`active-filter--${namespaceItems.join("-")}`}
        onClick={onClick}
      >
        <CombinedNamespacePaths namespacePaths={(namespaceItems)} />
        <i className="fa fa-times-circle supress-panel-styles pl10" />
      </QESButton>
    </li>
  );
}

/** Renders the separator that is interleaved with the groups. */
function AndSeparator() {
  return <li className="resource-filter-separator">and</li>;
}

export { ActiveFilters };
